import { m8API } from 'services/production/m8';
import { PartnerPasswordChangeFormSubmitService } from 'types/services';

export const submitPartnerPasswordChangeForm: PartnerPasswordChangeFormSubmitService = async (
  partnerId,
  formValues
) => {
  const { nextPassword, currentPassword } = formValues;

  if (partnerId) {
    await m8API.admin.updatePartnerPassword({
      idPartner: partnerId,
      password: nextPassword,
    });
  } else {
    await m8API.partner.updatePartnerPassword({
      password: currentPassword,
      newPassword: nextPassword,
    });
  }
};
